import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface PromoCodeDetailsRequest extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber?: string | null
    code: string
    prequoteId?: string | null
  }
}

export interface PromoCodeDetailsResponseData {
  currency?: string
  description?: string
  effectiveFrom?: string
  effectiveTo?: string
  isPercent: boolean
  promoCode: string
  promoCodeId: number
  userId?: number | null
  value: number
}

export interface PromoCodeDetailsResponse extends AxiosResponse {
  data: PromoCodeDetailsResponseData
}

export function promoCodeDetailsApi(
  {
    params,
    method = "get",
    url = `/promo/code/${params.code}/details`,
    ...config
  }: PromoCodeDetailsRequest,
  axiosInstance: AxiosInstance,
): Promise<PromoCodeDetailsResponse> {
  const requestParams: Record<string, string> = {}

  if (params.prequoteId) {
    requestParams.prequoteId = params.prequoteId
  }

  if (params.bookingNumber) {
    requestParams.bookingNumber = params.bookingNumber
  }

  return axiosInstance({
    method,
    params: requestParams,
    url,
    ...config,
  }) as Promise<PromoCodeDetailsResponse>
}
